export default function customerBulkDeleteService($http, RESOURCES) {
  return {
    deleteCustomers,
  };

  function deleteCustomers(emails) {
    return $http.put(RESOURCES.CUSTOMERS, { emails });
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/customer-bulk-delete/customer-bulk-delete.service.js